import React, { useState } from "react";

const FillInTheBlanksPrint = ({ question, highlightWords }) => {
  const [answers, setAnswers] = useState(Array(highlightWords.length).fill(""));

  const handleChange = (index, value) => {
    const updated = [...answers];
    updated[index] = value;
    setAnswers(updated);
  };

  // Function to render the sentence with blanks
  const renderWithBlanks = () => {
    const parts = [];
    let lastIndex = 0;

    highlightWords.forEach((wordObj, i) => {
      const { start, end } = wordObj;
      parts.push(question.slice(lastIndex, start));
      parts.push(
        <span
          style={{
            display: "inline-block",
            minWidth: "50px",
            textAlign: "center",
            borderBottom: "1px solid black",
            margin: "0 4px",
          }}
        />
      );
      lastIndex = end;
    });

    parts.push(question.slice(lastIndex));
    return parts;
  };

  return <>{renderWithBlanks()}</>;
};

export default FillInTheBlanksPrint;
